<div class="order-activity-dialog-wrapper">
	<div class="order-activity-table-wrapper">
		<p-table 
			[value]="activities" 
			*ngIf="!isLoading && activities.length > 0" 
			responsiveLayout="scroll"
			class="custom-scroll-table">
			<ng-template pTemplate="header">
				<tr>
					<th class="user-col">User</th>
					<th class="action-status-col">Action and Status</th>
					<th class="message-col">Message</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-activity let-rowIndex="rowIndex">
				<tr>
					<td class="user-col">
						<div class="user-info-column">
							<div class="user-name">
								{{ activity.user?.firstName || 'System' }} {{ activity.user?.lastName || '' }}
							</div>
							<div class="timestamp">
								{{ activity.created | date: 'MM/dd/yy h:mm a' }}
							</div>
						</div>
					</td>
					<td class="action-status-col">
						<div class="action">{{ activity.action }}</div>
						<div class="status">{{ activity.status }}</div>
					</td>
					<td class="message-col">
						<div class="message-col-container">			
							<div class="message-body-wrapper">
								<div class="message-row">
									<div #messageRef 
										class="message-body"
										[innerHTML]="expandedMap[rowIndex] ? activity.message : getClampedMessage(activity.message, rowIndex)"
										[ngClass]="{ 'clamped': !expandedMap[rowIndex] }">
									</div>
									<div *ngIf="clampMap[rowIndex]" 
										class="toggle-expand" 
										(click)="toggleExpand(rowIndex)">
										{{ expandedMap[rowIndex] ? 'Show less' : 'Show more' }}
									</div>
								</div>
							</div>
							<div class="copy-btn" *ngIf="activity.message?.trim()">
								<button 
									class="copy-button" 
									(click)="copyMessage(activity.message)" 
									title="Copy message">
									<i class="fa-light fa-copy"></i>
								</button>
							</div>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>

		<p *ngIf="isLoading" class="loading-activity">Loading activity 
			<i class="fa fa-spinner spinning"></i>
		</p>
		<div class="no-activity-found" *ngIf="!isLoading && activities.length === 0">
				<i class="fa-regular fa-cloud-question"></i>
				<div class="no-activity-found-message">
					No activity found.
				</div>
		</div>
	</div>

	<div class="footer-button-wrapper">
		<button 
			pButton 
			type="button" 
			class="p-button-secondary p-button-outlined p-button-sm" 
			(click)="close()"
			label="Close">
		</button>
	</div>
</div>